<template>
  <el-dialog
    v-el-dialog-drag
    show-close
    :visible.sync="visible"
    width="400px"
    title="生成账单"
    :close-on-click-modal="false"
    :before-close="() => close()"
  >
    <el-form
      ref="form"
      :model="formData"
      label-position="left"
      label-width="80px"
      inline-message
    >
      <el-row>
        <el-form-item label="承运商">
          <dict-select
            filterable
            v-model="formData.carrierScope"
            url="/master/carrier/info/select"
            placeholder="请选择承运商"
            clearable
            multiple
          ></dict-select>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="运单状态">
          <el-select
            v-model="formData.wayBillStatus"
            multiple
            filterable
            clearable
            default-first-option
            style="width:100%"
            placeholder="请选择运单状态"
          >
            <!-- <el-option label="新建" value="0"> </el-option> -->
            <!-- <el-option label="已派单" value="2"> </el-option> -->
            <el-option label="运输中" value="3"> </el-option>
            <el-option label="已完成" value="4"> </el-option>
            <el-option label="部分送达" value="5"> </el-option>
            <el-option label="验收中" value="6"> </el-option>
            <el-option label="待完成" value="7"> </el-option>
          </el-select>
        </el-form-item>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button size="small" @click="close()">取消</el-button>
      <el-button type="primary" size="small" @click="confirmGener()">
        确认生成
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {
        carrierScope: [],
        wayBillStatus: [],
      },
    }
  },
  methods: {
    async confirmGener() {
      const loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .finCarrierStatementChartersGenerateBill(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('reload')
          this.close()
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
